import React, { useEffect, useState,useRef } from "react";
import { canCatalogue } from '../permissions/access';
import { Link, useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import animationData from '../../assets/animation-data/loader.json'
import Lottie from 'react-lottie';
import { Addicon, Dots, Mail, Msz, SettingsIcon } from "../SvgIcon";
import SettingSidebar from "../settings/SettingSidebar";
import AddCard from '../addCardPopup/addCard';
import { marketingAction } from "../../_actions/marketing.actions";
import toast from '../shared/Toast';
import Draggable from 'react-draggable';
import CatalogueTopNav from "./CatalogueTopNav";
import '../forms/Forms.css';
import '../pos/POS.css';
import './service.css';
import { HiDotsVertical } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { RiSettings5Fill } from "react-icons/ri";
import { FiMenu } from "react-icons/fi";
import { Dropdown, Modal } from "react-bootstrap";
import { openOnboardingLayer } from "../onboarding/ImportJobContext";
import { ONBOARDING_ENABLED } from "../onboarding/flags";
import { HiBars2 } from "react-icons/hi2";
import { BsDisplay, BsDot } from "react-icons/bs";
import { TbMenu } from "react-icons/tb";

import Select from "react-select";
import FiltersPopup from "./FiltersPopup";
import ServicePopup from "./ServicePopup";
import MessagePopupBody from "./MessagePopupBody";
import { FaFilter } from "react-icons/fa";
import useWindowSize from "./useWindowSize";
import MobileDotPopup from "./MobileDotPopup";
import { newServicesAction } from "../../_actions";
import DeleteConfirmationPopup from "../common/DeleteConfirmationPopup";
import { NewServiceSkeletop } from "../newSalon/SkletonLoader";
import CategoryItem from "./CategoryItem";
import ServiceDetailPanel from "./ServiceDetailPanel";
import ServiceEditorPanel from "./ServiceEditorPanel";
import CategoryDetailPanel from "./CategoryDetailPanel";
import CatalogueToolbar from '../shared/CatalogueToolbar';
import SlidePanel from '../shared/SlidePanel';
import './newservice.css';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSensors, useSensor, PointerSensor, TouchSensor } from '@dnd-kit/core';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ServiceSubNav from "./ServiceSubNav";
import ServiceData from "./ServiceData";
import ServiceHelp from "./ServiceHelp";
import StarterEmptyState from "../onboarding/StarterEmptyState";

const SERVICE_SUBTITLES = {
  services: 'Your services, categories, pricing, and online booking.',
  data: 'Who upsells, what clients add at checkout, and what really pays per hour. Money reports live in Finance.',
};






function NewServices(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  
  // Determine if user is salon owner or self-employed for featured services.
  // Falls back to localStorage when Redux is stale (e.g. between cold start
  // and the boot-time profile refetch landing) — without this, the "Salon
  // Featured Services" category would briefly omit until the profile call
  // resolves. localStorage stores the user object directly (no userInfo
  // wrapper); see hairdresserSwitchProfile in hairdresser.actions.js for
  // where it's written.
  const localUser = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch (e) { return {}; }
  })();
  const isAccountHolder =
    props?.user?.userInfo?.hairdresser?.isSalonOwner === 1
    || localUser?.hairdresser?.isSalonOwner === 1;
  const seOwnBook = !isAccountHolder && (
      props?.user?.userInfo?.hairdresser?.employmentTypeId === 2
      || localUser?.hairdresser?.employmentTypeId === 2
    );
  // Roles & permissions: an employed team member whose role has `catalogue`
  // works the salon's catalogue exactly as the owner does (the server agrees).
  const isSalonOwner = isAccountHolder || (!seOwnBook && canCatalogue(false));
  const isSelfEmployed =
    !isSalonOwner && (
      props?.user?.userInfo?.hairdresser?.employmentTypeId === 2
      || localUser?.hairdresser?.employmentTypeId === 2
    );
  const [filterPopup, setFilterPopup]= useState(false)
  const [subTab, setSubTab] = useState('services'); // 'services' (the list) | 'data'
  const [serviceHelpOpen, setServiceHelpOpen] = useState(false);
  const [servicePopup,setServicePopup]=useState(false);
  const [deleteServicePopup, setDeleteServicePopup]= useState(false);
  const [detailPanelService, setDetailPanelService] = useState(null);
  const [detailPanelCategory, setDetailPanelCategory] = useState(null);
  const filterRef = useRef(null);
  const settingsRef = useRef(null);
  const [editServicePopup, setEditServicePopup]= useState(false);
  const [addCategoryPopup, setAddCategoryPopup]= useState(false);
  const [newCategoryPopup, setNewCategoryPopup] = useState(false);
  const [newCategoryAnimate, setNewCategoryAnimate] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategorySaving, setNewCategorySaving] = useState(false);
  const [newServicePanelOpen, setNewServicePanelOpen] = useState(false);
  const [editCategoryPopup, setEditCategoryPopup]= useState(false);
  const [deleteCategoryPopup, setDeleteCategoryPopup]= useState(false);
  const [staffLists ,setStaffLists] = useState(['hi','hello','jss','sds'])
  const staffList = ['hi','hello','jss','sds'];
  const { width } = useWindowSize();
  const[mobileDotCategory ,setMobileDotCategory] = useState(false)
  const[mobileDotService , setMobileDotService] = useState(false)
  const allServiceListData = useSelector(state=>state?.newServices?.listServices);
  console.log("allServiceListDataallServiceListData->",allServiceListData);
  const [searchCrossIcon, setSearchCrossIcon] = useState(""); 
  const initializeFilters = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
        teamMemberName: searchParams.get('teamMemberName') || "",
        teamMember: searchParams.get('teamMember') || "",
        servicesEnabled: searchParams.get('servicesEnabled') || "",
        onlineBookings: searchParams.get('onlineBookings') || "",
        searchQuery: searchParams.get('searchQuery') || ""
    };
  };
  const [filters, setFilters] = useState(initializeFilters());
  const [searchQuery, setSearchQuery] = useState(initializeFilters().searchQuery);

  const [services, setServices] = useState([]);
  const [isLoader, setIsLoader] = useState(false)

  const categoryRefs = useRef([]);
  const serviceRefs = useRef({});
  const [showFilters, setShowFilters] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartTime, setDragStartTime] = useState(0);
  const [dragStartPosition, setDragStartPosition] = useState({ x: 0, y: 0 });
  const [touchStartPosition, setTouchStartPosition] = useState({ x: 0, y: 0 });
  const [touchStartY, setTouchStartY] = useState(null);
  const [currentDragIndex, setCurrentDragIndex] = useState(null);
  const [dragOffset, setDragOffset] = useState(0);
  const [touchStartTime, setTouchStartTime] = useState(0);
  const [isTap, setIsTap] = useState(false);
  const [editcategoryPayload,setEditcategoryPayload]=useState({})
  const [selectedCategoryId,setSelectedCategoryId] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [selectedNotAssigned ,setSelectedNotAssigned] = useState()
  const [selectedCategoryName, setSelectedCategoryName] = useState();
  const [selectedServiceName, setSelectedServiceName] = useState();
  const [animate, setAnimate] = useState(false);
  const [categoryEditdetail , setCategoryEditdetail] = useState({id:"",name:""})
  const [serviceEditdetail ,setServiceEditdetail] = useState({})
  const [draggedItem, setDraggedItem] = useState(null);
  const [selectedSetting,setSelectedSetting]=useState(0)
  const [resetFilterPayload, setResetFilterPayload] = useState(null);

  // ------for draginging-------
  // const [categories, setCategories] = useState(initialData);
  const [collapsedCategories, setCollapsedCategories] = useState({});
  // const [isDragging, setIsDragging] = useState(false);
  const [mouseDownPosition, setMouseDownPosition] = useState(null);
  const dragThreshold = 10; // pixels to determine if its a drag
  const openAllAcordian = () => {
    setServices(prevServices => {
      const allOpen = prevServices.every(category => category.isOpen);
      return prevServices.map(category => ({
        ...category,
        isOpen: !allOpen
      }));
    });
  };
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: dragThreshold,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250, // ------add a small delay for touch devices, for differciate b/w scroll and drag
        tolerance: 5, // ---allow some movement before activating
      },
    })
  );

  const handleDragStart = (event) => {
    const { active } = event;
    
    if (!active.data.current?.type) {
      if (services?.find(cat => cat.id === active.id)) {
        setIsDragging(true);
        const allCollapsed = services?.reduce((acc, cat) => {
          acc[cat.id] = true;
          return acc;
        }, {});
        setCollapsedCategories(allCollapsed);
      }
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.data.current?.type === 'item') {
      setServices(prevCategories => {
        const activeCategory = active.data.current.category;
        const category = prevCategories.find(cat => cat.id === activeCategory);
        
        if (!category) return prevCategories;

        const oldIndex = category.items.findIndex(item => item.id === active.id);
        const newIndex = category.items.findIndex(item => item.id === over.id);

        if (oldIndex === -1 || newIndex === -1) return prevCategories;

        const updatedCategories = prevCategories.map(cat => {
          if (cat.id === activeCategory) {
            const updatedServices = {
              ...cat,
              items: arrayMove(cat.items, oldIndex, newIndex)
            };
            handleServiceOrderChange(updatedServices);
            return updatedServices;
          }
          return cat;
        });

        // ----for scroll to the dragged service item
        setTimeout(() => {
          const element = document.getElementById(active.id);
          if (element) scrollToElement(element);
        }, 100);

        return updatedCategories;
      });
    } else {
      if (active.id !== over.id) {
        setServices(prevCategories => {
          const oldIndex = prevCategories.findIndex(cat => cat.id === active.id);
          const newIndex = prevCategories.findIndex(cat => cat.id === over.id);
          // Featured categories ("Salon Featured" / "My Featured") are pinned at the top
          // and cannot be moved or displaced by other categories.
          const activeCat = prevCategories[oldIndex];
          const overCat = prevCategories[newIndex];
          if (activeCat?.isFeaturedCategory || overCat?.isFeaturedCategory) {
            return prevCategories;
          }
          const newArray = arrayMove(prevCategories, oldIndex, newIndex);
          handleCategoryOrderChange(newArray);

          // ---scroll logic chnage
          setTimeout(() => {
            const element = document.getElementById(active.id);
            if (element) {
              const headerHeight = -60;
              const scrollPosition = element.offsetTop - headerHeight - 0;
              window.scrollTo({
                top: Math.max(0, scrollPosition),
                behavior: 'smooth'
              });
            }
          }, 100);

          return newArray;
        });
       
        if (isDragging) {
          setCollapsedCategories({});
        }
      }
    }
    
    setIsDragging(false);
    setMouseDownPosition(null);
  };

  const handleToggleAll = () => {
    console.log('Toggling all categories');
    const allCollapsed = services?.every(cat => collapsedCategories[cat.id]);
    
    if (allCollapsed) {
      setCollapsedCategories({});
    } else {
      const allClosed = services?.reduce((acc, cat) => {
        acc[cat.id] = true;
        return acc;
      }, {});
      setCollapsedCategories(allClosed);
    }
  };

  const handleCancelFilters = () => {
    setShowFilters(false);
  };
 
  const settingClick = () =>{
    setServicePopup(true)
  }

  const addCategory = () =>{
    setAddCategoryPopup(true)
  }

  const openNewCategoryPopup = () => {
    setNewCategoryName('');
    setNewCategoryPopup(true);
    setNewCategoryAnimate(true);
  };

  const closeNewCategoryPopup = () => {
    setNewCategoryAnimate(false);
    setNewCategoryPopup(false);
    setNewCategoryName('');
    setNewCategorySaving(false);
  };

  const createCategory = (categoryName) => {
    const payload = { categoryName };
    setNewCategorySaving(true);
    dispatch(newServicesAction.createCategoryData(payload))
      .then((res) => {
        if (res?.newCategory?.statusCode === 1) {
          toast.success(res?.newCategory?.responseData?.message);
          // Multi-location: a new category exists at every location (menu structure is shared).
          const created = res?.newCategory?.responseData?.result;
          const catId = created && (created._id || (Array.isArray(created) && created[0] && created[0]._id));
          if (catId) require('../multiLocation/syncCatalogue').syncCatalogueAfterSave('category', String(catId), { mode: 'all', salonIds: [] });
          closeNewCategoryPopup();
          servicesList();
          categoryList();
        } else {
          toast.error(res?.newCategory?.error?.responseMessage);
          setNewCategorySaving(false);
        }
      })
      .catch((error) => {
        console.error("Error creating category:", error);
        toast.error("Failed to add category");
        setNewCategorySaving(false);
      });
  };

  const submitNewCategory = () => {
    const name = newCategoryName.trim();
    if (!name || newCategorySaving) return;
    createCategory(name);
  };
  // Starter menu added from the empty state (onboarding layer): reload.
  useEffect(() => {
    const onChanged = () => servicesList();
    window.addEventListener('beu:catalogue-changed', onChanged);
    return () => window.removeEventListener('beu:catalogue-changed', onChanged);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const servicesList = (selectedFilters) => {
    // console.log("servicesList_selectedFilters",selectedFilters)
    setIsLoader(true)
    // debugger
    const payload = {
      hairdresserId: selectedFilters?.teamMember || filters.teamMember || '', 
      onlineBooking: selectedFilters?.onlineBookings || filters.onlineBookings || '',
      status: selectedFilters?.servicesEnabled || filters.servicesEnabled || '',
      search: selectedFilters?.searchQuery || filters.searchQuery || ''
    }

  
      if(payload.search!=''){
      setSearchCrossIcon(true);
    }

    // console.log("payloadpayload",payload)
    dispatch(newServicesAction.listServicesData(payload))
      .then((res) => {
        // console.log("Services list successfully:", res,res?.shareService);
        setSelectedSetting(res?.shareService )
        setIsLoader(false)
      })
      .catch((error) => {
        console.error("Error with Services list:", error);
        setIsLoader(false)
      });

  }

  const areObjectsEqual = (obj1, obj2) => {
    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
      return obj1 === obj2; // Primitive comparison
    }
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (let key of keys1) {
      if (!keys2.includes(key) || !areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    return true;
  };

// ----for filter 
 useEffect(() => {
  // debugger
  // get the filter from location url
  const currentFilters = initializeFilters();
  // check with updatedFilters if both are same don;t so anything
  if(areObjectsEqual(currentFilters, filters)) return ;
    
  // update the filters with currentFilters
  setFilters({...filters, ...currentFilters});
  servicesList(currentFilters);
  // update the query field
  setSearchQuery(currentFilters.searchQuery);
}, [location.search])

// Add this useEffect to handle filter updates
useEffect(() => {
  if (resetFilterPayload) {
      // console.log("Updated filters:", filters);
      servicesList(resetFilterPayload);
      setResetFilterPayload(null);
  }
}, [filters, resetFilterPayload]);

  const updateQueryParams = (newFilters) => {
    // debugger;
        const searchParams = new URLSearchParams();
            // Only add params that have values

      if (newFilters.teamMember) searchParams.set('teamMember', newFilters.teamMember);
      if (newFilters.teamMemberName) searchParams.set('teamMemberName', newFilters.teamMemberName);
      if (newFilters.servicesEnabled) searchParams.set('servicesEnabled', newFilters.servicesEnabled);
      if (newFilters.onlineBookings) searchParams.set('onlineBookings', newFilters.onlineBookings);
      if (newFilters.searchQuery) searchParams.set('searchQuery', newFilters.searchQuery);


        // const queryString = searchParams.toString();
        history.push({
          pathname: '/new-services',
          search: `?${searchParams.toString()}`
        });
  };
  const filterClick = () =>{
    setFilterPopup(true);
  }
  const handleApplyFilters = (selectedFilters) => {
    // console.log('Applied filters:', selectedFilters);
    const updatedFilters = {
        ...filters,          
        ...selectedFilters,
        searchQuery: searchQuery 
    };
    setFilters(updatedFilters);
    setFilterPopup(false);
    updateQueryParams(updatedFilters); 

  };
  const handleRestFilters = (resetFiltersName) => {
    
    const resetFilters = { ...filters }; 

    if (resetFiltersName === 'teamMemberName') {
        resetFilters.teamMemberName = "";
        resetFilters.teamMember = ""; 
    }
    else if (resetFiltersName === 'servicesEnabled') {
        resetFilters.servicesEnabled = ""; 
    }
    else if (resetFiltersName === 'onlineBookings') {
        resetFilters.onlineBookings = ""; 
    }

    // Update Query params
    updateQueryParams(resetFilters)
    // set filters
    setFilters(resetFilters);
    setResetFilterPayload(resetFilters);
  };
  const handleClearAllFilters = () => {
    const resetFilters = { ...filters, teamMemberName: "", teamMember: "", servicesEnabled: "", onlineBookings: "" };
    updateQueryParams(resetFilters);
    setFilters(resetFilters);
    setResetFilterPayload(resetFilters);
  };
  const categoryList = () => {
    const payload = {}
    dispatch(newServicesAction.listCategoryData(payload))
      .then((res) => {
        // console.log("Category list successfully:", res);
       
      })
      .catch((error) => {
        console.error("Error with category list:", error);
      });
  }
  const handleSearchChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    if(value){
        setSearchCrossIcon(true)
    }
    else{
        setSearchCrossIcon(false) 
    }

    setSearchQuery(value); 
    const updatedFilters = {
        ...filters,
        searchQuery: value
    };

    updateQueryParams(updatedFilters); 
    setFilters(updatedFilters);
    setResetFilterPayload(updatedFilters)
    
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    if (pastedData!=''){
      setSearchCrossIcon(true)
      setSearchQuery(pastedData)
      const updatedFilters = {
        ...filters,
        searchQuery: pastedData
    };
    setFilters(updatedFilters);
        updateQueryParams(updatedFilters);
        servicesList(updatedFilters);
      // servicesList({"searchQuery": pastedData});
    }
    else if(pastedData=='' || searchQuery){
      setSearchCrossIcon(false)
    }
  };
  const handleResetSearcChange = ()=>{
    setSearchQuery("");
    setSearchCrossIcon(false);
    const updatedFilters = {
        ...filters,
        searchQuery: ""
    };

    updateQueryParams(updatedFilters);
    setFilters(updatedFilters);
    setResetFilterPayload(updatedFilters)
  }
  const handleCategoryOrderChange =(newServices) =>{
    // console.log("handleCategoryOrderChange-----services",newServices)
    const allcategoryIdList =newServices?.map(item=>item.id)
    const payload={
          "categoryId":allcategoryIdList.join(',')
    }
    // console.log("handleCategoryOrderChange-----",payload)
    dispatch(newServicesAction.categoryOrderChange(payload))
      .then((res) => {
        console.log("category OrderChange list successfully:", res);
       
      })
      .catch((error) => {
        console.error("Error with category OrderChange  list:", error);
      });
  }
  const handleServiceOrderChange =(newServices) =>{
    // console.log("handleServiceOrderChange-----services",newServices)
    
    // Check if this is the featured services category
    if (newServices?.isFeaturedCategory) {
      // For featured services, update the featuredOrder
      // Use the featuredType from the category (salon or staff)
      const featuredType = newServices?.featuredType || 'salon';
      // Use originalId for API calls (strip the prefix used for drag-and-drop uniqueness)
      const serviceIds = newServices?.items?.map(item => item.originalId || item.id);
      
      const payload = {
        serviceIds: serviceIds,
        featuredType: featuredType
      };
      
      dispatch(newServicesAction.updateFeaturedOrderData(payload))
        .then((res) => {
          console.log("Featured order change successful:", res);
        })
        .catch((error) => {
          console.error("Error with featured order change:", error);
        });
    } else {
      // Regular service order change
      const allServiceIdList = newServices?.items?.map(item => item.id);
      const payload = {
        "commonServiceId": allServiceIdList.join(',')
      };
      // console.log("handleServiceOrderChange-----",payload)
      dispatch(newServicesAction.serviceOrderChange(payload))
        .then((res) => {
          console.log("service OrderChange list successfully:", res);
        })
        .catch((error) => {
          console.error("Error with service OrderChange  list:", error);
        });
    }
  }
  const handleClose = () => {
    setAnimate(false);
    const timer = setTimeout(() =>
      setTimeout(() => setMobileDotService(false) , 300) ||  
      setTimeout(() => setFilterPopup(false), 300))
    const filterTimer= setTimeout(()=> setFilterPopup(false), 300 )  
    const timers =  setTimeout(() => setMobileDotService(false) , 300) ;
    const timer1 =setTimeout(() => setMobileDotCategory(false), 300);
    const  timer3 = setTimeout(()=> setServicePopup(false)  , 300)
    // return () => clearTimeout(timer,timers,timer1);
    return () => clearTimeout(timer,timers,timer1,filterTimer,timer3);
  };
  //mobile category edtit popup
  const mobileDotCategoryPopup = (categoryId, categoryName) =>{
    setMobileDotCategory(true)
    setCategoryEditdetail({ id: categoryId, name: categoryName });
  }
  // --edit category button click function
  const editCategory = (categoryId, categoryName) =>{
    // debugger
    setEditCategoryPopup(true)
    let payload = {
      "categoryId": categoryId,
      "categoryName": categoryName
    }
    setEditcategoryPayload(payload)
  }
 // --edit category Popup button click function
  const handleEditCategory = (categoryName) => {
    let payload = {
      "categoryId": editcategoryPayload.categoryId,
      "categoryName": categoryName
    }
    dispatch(newServicesAction.editCategoryData(payload))
      .then((res) => {
        console.log("Category edited successfully:", res);
        if(res?.editCategory?.statusCode===1) {
          toast.success(res?.editCategory?.responseData?.message);
       }
       else{
         toast.error(res?.editCategory?.error? res?.editCategory?.error?.responseMessage : res?.editCategory?.responseData?.message);
       }
        servicesList()
        setEditCategoryPopup(false)
        
        
      })
      .catch((error) => {
        console.error("Error edit category:", error);
      });
  };
  // --delete category button click function
  const deleteCategory = (categoryId ,categoryName) =>{
    setSelectedCategoryId(categoryId)
    setSelectedCategoryName(categoryName)
    setDeleteCategoryPopup(true);
  }
  // --delete service button click function
  const deleteService = (serviceId , serviceName ,notAssigned) =>{
    // debugger
    // console.log("serviceId_serviceName_notAssigned",serviceId , serviceName ,notAssigned)
    setSelectedServiceId(serviceId)
    setSelectedServiceName(serviceName)
    setSelectedNotAssigned(notAssigned)
    setDeleteServicePopup(true)
  }
  //mobile service edtit popup
  const listHairdresseData =()=>{
    // debugger
    let payload = { }
    dispatch(newServicesAction.listHairDresserData(payload))
      .then((res) => {
        console.log("listHairdresserlistHairdresser3333", res);
      })
      .catch((error) => {
        console.error("Error edit category:", error);
      });
  }
  const mobileDotServicePopup = (serviceDetail) =>{
    // debugger
    listHairdresseData()

    // console.log("mobileDotServicePopupmobileDotServicePopup",serviceDetail)
    setServiceEditdetail(serviceDetail)
    setMobileDotService(true)
  }
 // all useEffect code here
  useEffect(() => {
    if (servicePopup || filterPopup || mobileDotCategory ) {
      setAnimate(true);
    }
  }, [servicePopup,filterPopup,mobileDotCategory]);

  useEffect(() => {
    if (filterPopup || servicePopup) {
      document.body.classList.add('filter_modal_body');
    }
    
    // Clean
    return () => {
      document.body.classList.remove('filter_modal_body');
    };
  }, [filterPopup,servicePopup])
  useEffect(() => {
    // Map allServiceListData to the structure for services
    if (allServiceListData) {
        // Collect featured services from all categories - separate salon and staff featured
        const salonFeaturedServices = [];
        const staffFeaturedServices = [];
        
        allServiceListData.forEach(service => {
          if (service?.serviceList) {
            service.serviceList.forEach(item => {
              const baseServiceData = {
                originalId: item?.commonServiceId, // Keep original ID for API calls
                name: item?.serviceName,
                description: item?.serviceDescription,
                duration: item?.serviceTime,
                price: item?.servicePrice,
                deposit: item?.depositPrice,
                processingTime: item?.processingTime,
                notAssigned: item?.notAssigned,
                isFeaturedForSalon: item?.isFeaturedForSalon,
                isFeaturedForStaff: item?.isFeaturedForStaff,
                featuredOrder: item?.featuredOrder || 0,
                originalCategory: service?.categoryName,
                fromPrice: item?.fromPrice,
                fromDuration: item?.fromDuration,
                fromDeposit: item?.fromDeposit,
                staffCount: item?.staffCount || 0,
                staffPreview: item?.staffPreview || [],
              };

              // Add to salon featured if featured for salon
              // Use prefixed ID to make it unique across categories
              if (item?.isFeaturedForSalon) {
                salonFeaturedServices.push({
                  ...baseServiceData,
                  id: `salon-${item?.commonServiceId}`, // Prefixed ID for drag-and-drop uniqueness
                  featuredOrder: item?.featuredOrderSalon || item?.featuredOrder || 0
                });
              }
              
              // Add to staff featured if featured for staff
              // Use prefixed ID to make it unique across categories
              if (item?.isFeaturedForStaff) {
                staffFeaturedServices.push({
                  ...baseServiceData,
                  id: `staff-${item?.commonServiceId}`, // Prefixed ID for drag-and-drop uniqueness
                  featuredOrder: item?.featuredOrderStaff || item?.featuredOrder || 0
                });
              }
            });
          }
        });
        
        // Sort featured services by featuredOrder
        salonFeaturedServices.sort((a, b) => (a.featuredOrder || 0) - (b.featuredOrder || 0));
        staffFeaturedServices.sort((a, b) => (a.featuredOrder || 0) - (b.featuredOrder || 0));
        
        // Map regular categories
        const mappedServices = allServiceListData.map(service => ({
            id: service?._id,
            category: service?.categoryName,
            isOpen: true,
            items: service?.serviceList?.map(item => ({
              id: item?.commonServiceId,
              name: item?.serviceName,
              description: item?.serviceDescription,
              duration: item?.serviceTime,
              price: item?.servicePrice,
              deposit: item?.depositPrice,
              processingTime: item?.processingTime,
              notAssigned: item?.notAssigned,
              isFeaturedForSalon: item?.isFeaturedForSalon,
              isFeaturedForStaff: item?.isFeaturedForStaff,
              featuredOrder: item?.featuredOrder,
              fromPrice: item?.fromPrice,
              fromDuration: item?.fromDuration,
              fromDeposit: item?.fromDeposit,
              staffCount: item?.staffCount || 0,
              staffPreview: item?.staffPreview || [],
          }))
        }));
        
        // Build the final services array with featured categories at the top
        const finalServices = [];
        
        // Add Salon Featured Services category if there are salon featured services
        // Only show for salon owners
        if (isSalonOwner && salonFeaturedServices.length > 0) {
          finalServices.push({
            id: 'salon-featured-services',
            category: 'Salon Featured Services',
            isOpen: true,
            isFeaturedCategory: true,
            featuredType: 'salon',
            items: salonFeaturedServices
          });
        }
        
        // Add My Featured Services category if there are staff featured services
        // Show for all users (salon owners can also have their own featured services)
        if (staffFeaturedServices.length > 0) {
          finalServices.push({
            id: 'staff-featured-services',
            category: 'My Featured Services',
            isOpen: true,
            isFeaturedCategory: true,
            featuredType: 'staff',
            items: staffFeaturedServices
          });
        }
        
        // Add regular categories
        finalServices.push(...mappedServices);
        
        setServices(finalServices);
        
    }
    else{
      setIsLoader(true)
    }
  }, [allServiceListData, isSalonOwner, isSelfEmployed]);

  useEffect(() => {
    servicesList()
  },[])
  const deleteCategoryMsz ={
    heading :`Delete Category - ${selectedCategoryName}`,
    discription:"Are you sure you want to delete this category? This will also delete all services within this category for all staff using this category and these services. This action cannot be undone.",
    btntext1:"Cancel",
    btntext2:"Delete",
  }
  const deleteServiceMsz ={
    heading :`Delete Service - ${selectedServiceName}`,
    headingAssigned:'This service is currently in use, would you like to disable it instead?',
    discriptionAssigned:'This service is currently in use by other staff members so cannot be deleted. Would you like to disable this service instead?',
    discription:"Are you sure you want to delete this service? This will delete it for all other staff using this service too. This action cannot be undone.",
    btntext1:"Cancel",
    btntext2:"Delete"
  }

  // console.log("this_props_selectedCheckoutList new-services page",props)
  // console.log("new_service_props",props?.user?.userInfo)
  return (

    <div className="h_n _new__service catalogue-no-header">
      {/* {console.log("11111111111",mobileDotService,mobileDotCategory)} */}
      <div className="body_container cm_bg_white">
        <div className="catalogue-page-wrapper">
          <CatalogueTopNav>
            <Dropdown className="catalogue-add-dropdown">
              <Dropdown.Toggle id="catalogue-add-services">
                <span>Add</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setNewServicePanelOpen(true)}>New Service</Dropdown.Item>
                <Dropdown.Item onClick={openNewCategoryPopup}>New Category</Dropdown.Item>
                {ONBOARDING_ENABLED && <Dropdown.Item onClick={() => openOnboardingLayer({ mode: 'import' })}>Import from a file</Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown>
          </CatalogueTopNav>
          {newServicePanelOpen && (
            <ServiceEditorPanel
              onClose={() => setNewServicePanelOpen(false)}
              onSaved={() => {
                setNewServicePanelOpen(false);
                servicesList();
              }}
            />
          )}

          {/* Page header + sub-nav (Services / Data), matching the Products area.
              The existing services management is the Services tab; Data is the
              new catalogue-intelligence view. */}
          <div className="pv2-head">
            <div className="pv2-title-row">
              <h1 className="pv2-title">Services</h1>
              <button type="button" className="pv2-help-btn" onClick={() => setServiceHelpOpen(true)} aria-label="How services work" title="How services work">?</button>
            </div>
            <p className="pv2-sub">{SERVICE_SUBTITLES[subTab]}</p>
          </div>
          {serviceHelpOpen && <ServiceHelp onClose={() => setServiceHelpOpen(false)} />}
          <ServiceSubNav active={subTab} onChange={setSubTab} counts={{ services: (services && services.length) || undefined }} />

          <div className="catalogue-content-container" style={subTab === 'data' ? { display: 'none' } : undefined}>
            <div className="catalogue-content-wrapper">
                <CatalogueToolbar
                    searchValue={searchQuery}
                    onSearchChange={handleSearchChange}
                    onSearchPaste={handlePaste}
                    onSearchClear={handleResetSearcChange}
                    showClear={searchCrossIcon}
                    placeholder="Search services..."
                    onFilterClick={filterClick}
                    onSettingsClick={settingClick}
                />
                {(filters?.teamMemberName || filters?.servicesEnabled || filters?.onlineBookings) && (
                  <div className="applied_filter_container">
                    {filters.teamMemberName && (
                      <span>
                        {filters.teamMemberName} 
                        <i className="_cross" onClick={() => handleRestFilters('teamMemberName')}><RxCross2 /></i>
                      </span>
                    )}
                    {filters.servicesEnabled && (
                      <span>
                        {filters.servicesEnabled === "true" ? 'Services Enabled' : 'Services Disabled'} 
                        <i className="_cross" onClick={() => handleRestFilters('servicesEnabled')}><RxCross2 /></i>
                      </span>
                    )}
                    {filters.onlineBookings && (
                      <span>
                        {filters.onlineBookings === "true" ? 'Online Bookings Enabled' : 'Online Bookings Disabled'}
                        <i className="_cross" onClick={() => handleRestFilters('onlineBookings')}><RxCross2 /></i>
                      </span>
                    )}
                    <button type="button" className="applied_filter_clear" onClick={handleClearAllFilters}>Clear all</button>
                  </div>
               )}
                {isLoader?<NewServiceSkeletop/>:
                <>
                {/* {console.log("servicesservices",services)} */}
                {services.length == 0 ? (
                  (searchQuery || Object.values(filters || {}).some(Boolean))
                    ? <p className="text-center mt-5">No services match these filters</p>
                    : <StarterEmptyState onAddService={() => setNewServicePanelOpen(true)} />
                ):
                   <div className="App">
                    <DndContext 
                    collisionDetection={closestCenter} 
                    onDragEnd={handleDragEnd}
                    onDragStart={handleDragStart}
                    modifiers={[restrictToVerticalAxis]}
                    sensors={sensors}
                  >
                    <div className="app">
                      {/* <div className="categories-container"> */}
                      <div className="_dragable_component pt-4">
                        <SortableContext 
                          items={services.map((category, categoryIndex) =>category.id)} 
                          strategy={verticalListSortingStrategy}
                        >
                          {services.map((category, categoryIndex) => (
                            <CategoryItem
                              key={category.id}
                              category={category}
                              isCollapsed={collapsedCategories[category.id]}
                              onToggleAll={handleToggleAll}
                              isDragging={isDragging}
                              mouseDownPosition={mouseDownPosition}
                              setMouseDownPosition={setMouseDownPosition}
                              dragThreshold={dragThreshold}
                              onOpenCategoryDetail={(cat) => setDetailPanelCategory(cat)}
                              mobileDotServicePopup={mobileDotServicePopup}
                              deleteService={deleteService}
                              onOpenServiceDetail={(service) => setDetailPanelService(service)}
                              handleCategoryOrderChange={handleCategoryOrderChange}
                              handleServiceOrderChange={handleServiceOrderChange}
                              isSalonOwner={isSalonOwner}
                              isSelfEmployed={isSelfEmployed}
                            />
                          ))}
                        </SortableContext>
                      </div>
                    </div>
                  </DndContext>
                 </div>
                }
                </>
                }


            </div>
          </div>
          {subTab === 'data' && (
            <div className="catalogue-content-container">
              <div className="catalogue-content-wrapper">
                <ServiceData currency="£" services={services} onOpenFinance={() => { window.location.href = '/finance?tab=transactions&type=service'; }} />
              </div>
            </div>
          )}
        </div>
      </div>
      {/* ---filter panel---   */}
      {filterPopup && (
        <SlidePanel
          title="Filters"
          onClose={handleClose}
          width={380}
          compact
          footer={
            <>
              <button className="bdp-btn bdp-btn--secondary" onClick={handleClose}>Cancel</button>
              <button className="bdp-btn bdp-btn--primary" onClick={() => filterRef.current && filterRef.current.apply()}>Apply</button>
            </>
          }
        >
                    <FiltersPopup
                    ref={filterRef}
                    onHide={handleClose}
                    onSend={handleApplyFilters}
                    filters={filters}
                    servicesList={servicesList}
                    {...props}
                    />
        </SlidePanel>
      )}
        {/* ---setting service panel---   */}
      {servicePopup && (
        <SlidePanel
          title="Service Settings"
          onClose={handleClose}
          width={380}
          compact
          footer={
            <>
              <button className="bdp-btn bdp-btn--secondary" onClick={handleClose}>Cancel</button>
              <button className="bdp-btn bdp-btn--primary" onClick={() => settingsRef.current && settingsRef.current.apply()}>Apply</button>
            </>
          }
        >
                    <ServicePopup
                    ref={settingsRef}
                    onHide={handleClose}
                    servicesList={servicesList}
                    selectedSetting={selectedSetting}
                    />
        </SlidePanel>
      )}

 
     


        {/* <MessagePopupBody
         centered="centered"
         show={editServicePopup} 
        onHide={()=>setEditServicePopup(false)} 
         backdropClassName="_light_bg"
         size="lg" 
         className='_service__popup'
         popupType="edit"
         message="Service"
        /> */}

        
       {/* ---Edit Category popup---   */}
        <MessagePopupBody
         blurClass="blure_bg"
         centered="centered"
         show={editCategoryPopup} 
         onHide={()=>setEditCategoryPopup(false)} 
         backdropClassName="_light_bg"
         size="lg" 
         className='_service__popup _no_animation'
         popupType="edit"
         message="Category"
         initialValue={editcategoryPayload.categoryName}
         submitFunction={handleEditCategory}
        />
        {/* ---delete Category popup---   */}
        <DeleteConfirmationPopup
          show={deleteCategoryPopup}
          onHide={() => setDeleteCategoryPopup(false)}
          itemType="serviceCategory"
          itemId={selectedCategoryId}
          itemName={selectedCategoryName}
          refreshList={servicesList}
        />
        {/* ---delete service popup---   */}
        <DeleteConfirmationPopup
          show={deleteServicePopup}
          onHide={() => setDeleteServicePopup(false)}
          itemType="service"
          itemId={selectedServiceId}
          itemName={selectedServiceName}
          refreshList={servicesList}
          notAssigned={selectedNotAssigned}
        />



        {/* -----for Dot category--- */}
        <MobileDotPopup 
        blurClass="blure_bg"
        centered="centered"
        show={mobileDotCategory} 
        onHide={handleClose}
        backdropClassName="_light_bg"
        dialogClassName={`bottom-modal ${animate ? 'slide-in' : 'slide-out'}`}
        size="lg" 
        className='_service__mobile_popup _no_animation'
        type="Category"
        details={categoryEditdetail}
        editOnClickPopup={()=>editCategory(categoryEditdetail.id , categoryEditdetail.name)}
        deleteOnClickPopup={()=>deleteCategory(categoryEditdetail?.id , categoryEditdetail?.name)}

        /> 
        {/* -----for Dot service--- */}
        {/* { console.log("mobileDotServicePopupmobileDotServicePopup11",serviceEditdetail)} */}
        <MobileDotPopup 
        blurClass="blure_bg"
        centered="centered"
        show={mobileDotService} 
        onHide={handleClose}
        backdropClassName="_light_bg"
        dialogClassName={`bottom-modal ${animate ? 'slide-in' : 'slide-out'}`}
        size="lg" 
        className='_service__mobile_popup _no_animation'
        details={serviceEditdetail}
        type="Service"
        deleteOnClickPopup={()=>deleteService(serviceEditdetail?.originalId || serviceEditdetail?.id , serviceEditdetail?.name ,serviceEditdetail?.notAssigned)}
        notAssigned={selectedNotAssigned}
        />

        {/* New Category — matches the Edit Category panel exactly. */}
        {newCategoryPopup && (
          <SlidePanel
            onClose={closeNewCategoryPopup}
            className="sdp-panel"
            width={380}
            compact
          >
            <div className="sdp-header">
              <div className="sdp-header-info">
                <h2 className="sdp-header-name">New Category</h2>
              </div>
              <button className="beu-icon-btn" onClick={closeNewCategoryPopup}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div className="sdp-body">
              <div className="sdp-section">
                <p className="beu-section-label">Category Name</p>
                <input
                  type="text"
                  className="cdp-name-input"
                  autoFocus
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') submitNewCategory(); }}
                  placeholder="Enter category name"
                />
              </div>
            </div>

            <div className="sdp-footer">
              <button
                type="button"
                className="sdp-btn sdp-btn--neutral"
                onClick={closeNewCategoryPopup}
              >
                Cancel
              </button>
              <button
                type="button"
                className="sdp-btn sdp-btn--primary"
                onClick={submitNewCategory}
                disabled={!newCategoryName.trim() || newCategorySaving}
              >
                {newCategorySaving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </SlidePanel>
        )}

        {detailPanelService && (
          <ServiceDetailPanel
            service={detailPanelService}
            onClose={() => setDetailPanelService(null)}
            onDelete={(id, name) => {
              setDetailPanelService(null);
              deleteService(id, name, detailPanelService?.notAssigned);
            }}
            onSaved={() => servicesList()}
            currency={props?.user?.userInfo?.hairdresser?.currencySymbol || '£'}
          />
        )}

        {detailPanelCategory && (
          <CategoryDetailPanel
            category={detailPanelCategory}
            onClose={() => setDetailPanelCategory(null)}
            onSave={(id, newName) => {
              dispatch(newServicesAction.editCategoryData({ categoryId: id, categoryName: newName }))
                .then((res) => {
                  if (res?.editCategory?.statusCode === 1) {
                    toast.success(res?.editCategory?.responseData?.message);
                  } else {
                    toast.error(res?.editCategory?.error?.responseMessage || res?.editCategory?.responseData?.message);
                  }
                  servicesList();
                  setDetailPanelCategory(null);
                })
                .catch((error) => console.error('Error editing category:', error));
            }}
            onDelete={(id, name) => {
              setDetailPanelCategory(null);
              deleteCategory(id, name);
            }}
            itemCount={detailPanelCategory.itemCount || 0}
            itemLabel="services"
          />
        )}

    </div>
  );

}

function mapStateToProps(state) {
  return {
      ...state
  };
}
export default connect(mapStateToProps)(NewServices);

const looptest = [0,0]

// const editCategoryMsz ={
//   heading :"Edit Category",
// }

// const editServiceMsz ={
//   heading :"Edit Service",
// }

// Add this helper function for smooth scrolling
const scrollToElement = (element) => {
  const headerHeight = 80;
  const scrollPosition = element.offsetTop - headerHeight - 10; // Added small offset for visual spacing
  window.scrollTo({
    top: Math.max(0, scrollPosition),
    behavior: 'smooth'
  });
};